import {sendReq} from "./SendRequest";
import {SalaryBonusPenaltyCreate, SalaryBonusPenaltyUpdate} from "../models/SalaryBonusPenalty";

export default class SalaryBonusPenaltyRAPI {
  static create(userId: number, data: SalaryBonusPenaltyCreate) {
    return sendReq(`users/${userId}/salary-bonuses`, 'POST', data);
  }

  static getAll(userId: number, params: { year: number; month: number; type?: string }) {
    return sendReq(`users/${userId}/salary-bonuses`, 'GET', params);
  }

  static update(id: number, data: SalaryBonusPenaltyUpdate) {
    return sendReq(`users/salary-bonuses/${id}`, 'PUT', data);
  }

  static delete(id: number) {
    return sendReq(`users/salary-bonuses/${id}`, 'DELETE');
  }
}